export const GET_LOCATIONS = 'GET_LOCATIONS';
export const GET_FLIGHTS = 'GET_FLIGHTS';
export const GET_TRIP = 'GET_TRIP';
export const GET_TYPE_DATES = 'GET_TYPE_DATES';
export const GET_DESTINIES = 'GET_DESTINIES';
export const GET_SELECTED_DESTINY = 'GET_SELECTED_DESTINY';
export const GET_ORIGINS_OPTIONS = 'GET_ORIGINS_OPTIONS';
export const GET_MORE_THAN_ONE_DAY_ORIGINS_OPTIONS = 'GET_MORE_THAN_ONE_DAY_ORIGINS_OPTIONS';
export const GET_FORMATTED_OPTIONS = 'GET_FORMATTED_OPTIONS';
export const GET_DESTINIES_OPTIONS = 'GET_DESTINIES_OPTIONS';
export const GET_DESTINIES_IMAGES = 'GET_DESTINIES_IMAGES';
export const GET_TOP_DESTINIES = 'GET_TOP_DESTINIES';
